if (!customElements.get('tgd-paypal-message')) {
  class TgdPayPalMessage extends HTMLElement {
    static sdkPromise;

    connectedCallback() {
      this.style.clear = 'both';
      this.message = this.querySelector('.tgd-paypal-message__content');
      this.productInfo = this.closest('product-info');
      this.price = Number(this.dataset.price);
      this.onQuantityChange = (event) => {
        if (event.target.name === 'quantity' && event.target.getAttribute('form') === this.dataset.formId) {
          this.updateAmount();
        }
      };
      this.productInfo?.addEventListener('change', this.onQuantityChange);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data.sectionId) !== this.dataset.sectionId) return;
          if (!event.data.variant) {
            this.hidden = true;
            return;
          }
          this.hidden = false;
          this.price = event.data.variant.price;
          this.updateAmount();
        });
      }

      this.updateAmount();
      this.loadSdk()
        .then((sdk) => {
          if (!this.isConnected) return;
          return sdk.Messages({
            placement: 'product',
            style: { layout: 'flex', color: 'white', ratio: '8x1' },
          }).render(this.message);
        })
        .catch(() => {
          this.hidden = true;
        });
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onQuantityChange);
      this.unsubscribeVariant?.();
    }

    updateAmount() {
      const quantityInput = this.productInfo?.querySelector('input[name="quantity"]');
      const quantity = Math.max(1, Number(quantityInput?.value) || 1);
      this.message.setAttribute('data-pp-amount', ((this.price * quantity) / 100).toFixed(2));
    }

    loadSdk() {
      if (window.tgdPayPalMessages?.Messages) return Promise.resolve(window.tgdPayPalMessages);
      if (TgdPayPalMessage.sdkPromise) return TgdPayPalMessage.sdkPromise;

      TgdPayPalMessage.sdkPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const query = new URLSearchParams({
          'client-id': this.dataset.clientId,
          currency: 'EUR',
          components: 'messages',
          locale: document.documentElement.lang.toLowerCase().startsWith('en') ? 'en_US' : 'de_DE',
          'enable-funding': 'paylater',
        });
        script.id = 'tgd-paypal-messages-sdk';
        script.src = `https://www.paypal.com/sdk/js?${query}`;
        script.dataset.namespace = 'tgdPayPalMessages';
        script.async = true;
        script.onload = () => resolve(window.tgdPayPalMessages);
        script.onerror = () => reject(new Error('PayPal messaging could not be loaded.'));
        document.head.appendChild(script);
      });

      return TgdPayPalMessage.sdkPromise;
    }
  }

  customElements.define('tgd-paypal-message', TgdPayPalMessage);
}
